module.exports = __webpack_public_path__ + "static/media/LogicWheel1_1_2.c7c67dad.png";